module.exports = __webpack_public_path__ + "img/center09.8a862899.png";